import React from "react";

export default function Contact() {
  return (
    <a  href="https://wa.me/0269138654?text=I would liketo know more about this hair style" title="Share on whatsapp" className="font-Lato text-slate-100 bg-pink-500 rounded p-3">
      Know more about the style
    </a>
  );
}
